<div style="border-left: 2px solid #fff; border-right: 2px solid #fff; padding: 0 10px 0 15px; margin-left: 8px;">
  <a (click)="openFeedback()" style="cursor: pointer;"  matTooltip="Laisser un commentaire sur le site">
    <mat-icon>feedback</mat-icon>
  </a>
</div>
